import { useEffect, useState } from 'react';
import { useAtomValue } from 'jotai';
import { MONTHLY_PLANS, YEARLY_PLANS } from '@/data/utils/plansData';
import axiosConfig from '@/data/utils/axiosConfigInstance';
import { userInfoAtom } from '@/data/atoms/utilsAtoms';
import PlanSwitcher from '@/v2/pages/Plans/components/plan-switcher';
import MyAccountPricingCarousel from './MyAccountPricingCarousel';
import CustomCheckoutModal from '../PlanPage/CustomCheckoutModal';
import './MyAccountPlanSelection.css';

function MyAccountPlanSelection() {
	const userData = useAtomValue(userInfoAtom);
	const [isYearly, setIsYearly] = useState(true);
	const [checkoutModal, setCheckoutModal] = useState({ open: false, plan: null });
	const [currentSubscriptionDetails, setCurrentSubscriptionDetails] = useState(null);
	const [currentSubscriptionLoading, setCurrentSubscriptionLoading] = useState(false);
	const isCancelledUser =
		currentSubscriptionDetails?.status === 'cancelled' ||
		(Boolean(userData.user?.isTrialAvailed) && userData.user?.subscription === false);

	const availablePlans = isYearly ? YEARLY_PLANS : MONTHLY_PLANS;

	useEffect(() => {
		if (!userData.subscriptionId) {
			setCurrentSubscriptionDetails(null);
			setCurrentSubscriptionLoading(false);
			return;
		}

		let isActive = true;
		setCurrentSubscriptionLoading(true);

		axiosConfig
			.get(`${import.meta.env.VITE_APP_API_URL}/chargebee/subscription-management-details`)
			.then(response => {
				if (isActive) {
					setCurrentSubscriptionDetails(response.data || null);
				}
			})
			.catch(error => {
				console.error('[MyAccountPlanSelection] Failed to load current subscription details:', error);
				if (isActive) {
					setCurrentSubscriptionDetails(null);
				}
			})
			.finally(() => {
				if (isActive) {
					setCurrentSubscriptionLoading(false);
				}
			});

		return () => {
			isActive = false;
		};
	}, [userData.subscriptionId]);

	return (
		<>
			<div className="my-account-plan-selection">
				<div className="my-account-plan-selection__header">
					<span className="my-account-plan-selection__eyebrow">Pick Your Plan</span>
					<div className="my-account-plan-selection__switcher">
						<PlanSwitcher onToggle={setIsYearly} />
					</div>
				</div>

				<MyAccountPricingCarousel
					plans={availablePlans}
					isYearly={isYearly}
					onOpenCheckout={setCheckoutModal}
					currentSubscriptionDetails={currentSubscriptionDetails}
					currentSubscriptionLoading={currentSubscriptionLoading}
				/>
			</div>

			<CustomCheckoutModal
				open={checkoutModal.open}
				onClose={() => setCheckoutModal({ open: false, plan: null })}
				plan={checkoutModal.plan}
				isCancelledUser={isCancelledUser}
			/>
		</>
	);
}

export default MyAccountPlanSelection;
